import React, { useState } from "react"
import LinkButton from "@components/common/LinkButton"
import { ArrowsOutSimpleIcon } from "@phosphor-icons/react"
import { navigate } from "gatsby"

const LookbookCard = ({ data, cardStyles, onClick }) => {
	const [hovered, setHovered] = useState(false)

	const onButtonClick = (e) => {
		if (!data?.url) e.preventDefault()
	}
	return (
		<React.Fragment>
			<div
				className={`relative flex-auto md:flex-1 w-full md:max-w-80 cursor-pointer`}
				onClick={() => {
					if (data?.onClick) data?.onClick()
					else if (data?.url) navigate(data?.url)
					else if (onClick) onClick(data)
				}}
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
			>
				<img
					className={`w-full h-[300px] sm:h-[345px] md:h-[540px] lg:h-[615px] object-cover `}
					src={data?.image}
					alt={data?.name}
				/>
				{data?.description && (
					<p className="product-description">{data?.description}</p>
				)}

				<div className="absolute w-full bottom-0 mx-auto mb-6">
					<LinkButton
						label={data?.buttonLabel}
						className={`tall-card-button ${
							hovered ? "btn-primary border-0" : ""
						}`}
						icon={<ArrowsOutSimpleIcon size={20} weight="light" />}
						to={data?.url ?? "#"}
						onClick={onButtonClick}
					/>
				</div>
			</div>
		</React.Fragment>
	)
}

export default LookbookCard
